
'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./service-worker.cjs.production.min.js')
} else {
  module.exports = require('./service-worker.cjs.development.js')
}
